import { MigrationSpec } from "../migration.models"

const csatReportWidgetTemplates: MigrationSpec = {
  type: "SEED_CSAT_REPORT_WIDGET_TEMPLATES",
  collection: "ReportWidgetTemplates",
  risk: "SAFE",
  title: {
    en: "CSAT → report widget templates",
    tr: "CSAT → rapor widget şablonları"
  },
  description: {
    en:
      "Inserts the eleven `csat` (live chat CSAT) report widget templates when missing: sent, " +
      "responses, rating distribution, response rate, CSAT score (overall, by user, AI vs " +
      "human, by channel), satisfaction rate (overall, by user) and the comment list. Written " +
      "with `$setOnInsert`, so a second run changes nothing and existing (possibly edited) " +
      "templates are never overwritten.",
    tr:
      "Eksikse on bir `csat` (canlı destek CSAT) rapor widget şablonunu ekler: gönderilen, " +
      "yanıtlanan, puan dağılımı, yanıt oranı, CSAT puanı (genel, kullanıcıya göre, AI ve " +
      "insan, kanala göre), memnuniyet oranı (genel, kullanıcıya göre) ve yorum listesi. " +
      "`$setOnInsert` ile yazılır: ikinci çalıştırma hiçbir şey değiştirmez, mevcut " +
      "(düzenlenmiş olabilecek) şablonların üzerine asla yazılmaz."
  },
  expectedDocuments: {
    filter: {
      dataSource: "csat",
      widgetType: {
        $in: [
          "csat_sent",
          "csat_responded",
          "csat_rating_distribution",
          "csat_response_rate",
          "csat_average_score",
          "csat_average_score_by_user",
          "csat_average_score_by_handled_by",
          "csat_average_score_by_channel",
          "csat_satisfaction_rate",
          "csat_satisfaction_rate_by_user",
          "csat_comments"
        ]
      }
    },
    count: 11
  },
  notes: [
    {
      en:
        "Run after “CSAT → report metric templates”: these widgets reference those metric " +
        "templates.",
      tr:
        "“CSAT → rapor metrik şablonları”ndan sonra çalıştırın: bu widget'lar o metrik " +
        "şablonlarına referans verir."
    },
    {
      en:
        "Deploy the api-v2 build that serves the `csat` data source first — an older build " +
        "cannot render these widgets.",
      tr:
        "Önce `csat` veri kaynağını sunan api-v2 sürümünü deploy edin — eski sürüm bu " +
        "widget'ları gösteremez."
    },
    {
      en:
        "After this and the metric templates have run, press “Create Default System Reports” " +
        "(CREATE_DEFAULT_SYSTEM_REPORTS) on the Scripts page once so tenants get the CSAT " +
        "system report (Conversations → CSAT). Until then that report is skipped for every " +
        "tenant.",
      tr:
        "Bu ve metrik şablonları çalıştıktan sonra, tenant'ların CSAT sistem raporunu " +
        "(Görüşmeler → CSAT) alması için Scripts sayfasındaki “Create Default System Reports” " +
        "(CREATE_DEFAULT_SYSTEM_REPORTS) düğmesine bir kez basın. O zamana kadar bu rapor her " +
        "tenant için atlanır."
    }
  ]
}

export default csatReportWidgetTemplates
